angular.module("avant.autocomplete")
  .directive "autocompleteItem",
  ["$compile", "$templateCache", ($compile, $templateCache) ->
    defaultTemplate = """
      <span>{{ item }}</span>
    """

    restrict: "A"
    scope: true
    link: (scope, $element) ->
      rawTemplate = $templateCache.get(scope.autocompleteTemplateUrl) || defaultTemplate
      compiledTemplate = $compile(rawTemplate)(scope)

      $element.append(compiledTemplate)

      $element.on "mouseover", ->
        scope.setActiveItem(scope.$index)
        scope.$apply()

      $element.on "mousedown", ($event) ->
        $event.preventDefault()

        scope.selectActiveItem()
        scope.dismissPopover()
        scope.$apply()
  ]